// Each step has its own identifier
export enum StepId {
  PERSONAL = 'personal',
  OBJECT = 'object',
  SUMMARY = 'summary',
  DONE = 'done',
}

// You can optionally divide steps into groups,
// each one having its own identifier
export enum StepCategoryId {}

export enum StepGroupId {}
